import { RocketOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { useRouter } from 'next/router'
import { useIntl } from 'react-intl'

import { ampli } from '@/ampli'
import { CalendlyModal } from '@/components/common/modals/CalendlyModal'
import { getMenuItem, MenuItem } from '@/components/ui/common/MenuItem'
import { buildI18nFunction } from '@/utils/messages'

const COMPONENT_ID = 'HeaderMenu.freeTrial'

export function FreeTrialButton(): JSX.Element {
  const t = buildI18nFunction(useIntl().formatMessage)

  const router = useRouter()

  return (
    <>
      <CalendlyModal key="link">
        {({ toggleCalendlyModal }) => (
          <Button
            block
            data-cy={'freeTrial-modal-button-cancel'}
            onClick={() => {
              toggleCalendlyModal(true)

              ampli.tryFullVersionClicked({
                pathname: router.pathname,
              })
            }}
            style={{ color: 'white', backgroundColor: '#08c404' }}
            type="default"
            icon={<RocketOutlined />}
          >
            {t(`${COMPONENT_ID}.button`)}
          </Button>
        )}
      </CalendlyModal>
    </>
  )
}

export function FreeTrialButtonMenuItem(): MenuItem & { 'data-cy': string } {
  return {
    'data-cy': `FreeTrialButton`,
    ...getMenuItem(<FreeTrialButton />, 'free-trial-button'),
  }
}
